import {isNullOrUndefined} from "../../../../services/Validator";

export default function FlashResultsDesktopGraphCardLayout({children}) {
    // Used in FlashResultsDesktopGraphCard to frame graph card
    // content (chart)

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"grow flex items-center justify-center py-16"}>
            {children}
        </div>
    );
}